module.exports = __webpack_public_path__ + "img/car.0d2f9a63.png";